import { render, staticRenderFns } from "./ResearchLive.vue?vue&type=template&id=8d873f50&scoped=true"
import script from "./ResearchLive.vue?vue&type=script&lang=js"
export * from "./ResearchLive.vue?vue&type=script&lang=js"
import style0 from "./ResearchLive.vue?vue&type=style&index=0&id=8d873f50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d873f50",
  null
  
)

export default component.exports